export default ({ theme }) => ({
  '& .premiumBtn': {
    width: 168,
    height: 44,
    fontSize: 14,
    backgroundColor: theme.palette.moreColors.yellow,
    border: 'none',
    '& .StyledButton-startIcon': {
      marginRight: 6,
      marginLeft: -3
    }
  },
  '& .postJobBtn': {
    position: 'relative',
    width: 168,
    height: 44,
    '& .StyledButton-startIcon': {
      marginRight: 21,
      marginLeft: 0
    }
  },
  '& .mobilePostJobBtnContainer': {
    display: 'none',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      display: 'block'
    }
  },
  '& .mobilePostJobBtn': {
    position: 'fixed',
    bottom: 42,
    left: '50%',
    zIndex: 50,
    transform: 'translateX(-50%)',
    width: 45,
    height: 45,
    display: 'none',
    boxShadow: '0 2px 4px 0 rgba(71,67,162,0.3)',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      display: 'flex'
    }
  },
  '& .jobsFilterBtn': {
    width: 'auto !important',
    marginLeft: 0,
    marginRight: 0,
    color: '#000'
  },
  '& .optionsPopupPaper': {
    minWidth: 255,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      borderRadius: 5
    }
  },
  '& .optionsPopupBtn': {
    width: '100%',
    height: 50,
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: 0,
    color: '#000',
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0,0,0,0.1)'
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      height: 50,
      fontSize: 16,
      lineHeight: '18px'
    }
  },
  '& .selectorPopupPaper': {
    maxWidth: 253,
    boxShadow: '0 8px 24px 0 rgba(0,0,0,0.2)',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      borderRadius: 5
    }
  },
  '& .selectorTriggerBtn': {
    color: '#000',
    '& .StyledButton-endIcon': {
      marginLeft: 0,
      marginRight: 0
    }
  },
  '& .selectorBtn': {
    width: '100%',
    height: 50,
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: 0,
    color: '#000',
    borderRadius: '0px !important',
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0,0,0,0.1)'
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      height: 50,
      fontSize: 16,
      lineHeight: '18px'
    }
  },
  '& .employeeCareerDevButton': {
    height: 44,
    width: 180,
    marginLeft: 15,
    fontSize: 14
  },
  '& .employeeJobsTabs': {
    minHeight: 'auto',
    '& .MuiTabs-indicator': {
      display: 'none'
    }
  },
  '& .employeeJobsTab': {
    minHeight: 'auto',
    minWidth: 'auto',
    height: 38,
    padding: 0,
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '17px',
    letterSpacing: 0,
    textTransform: 'capitalize',
    opacity: 1,
    color: theme.palette.primary.main,
    borderRadius: 19,
    '&:not(:first-of-type)': {
      marginLeft: 20
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      fontSize: 16,
      '&:not(:first-of-type)': {
        marginLeft: 24
      }
    },
    '&.Mui-selected': {
      padding: '0 34px',
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        padding: '0 24px'
      }
    }
  }
});
